import "./instrument";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import { initMediaAuth } from "@/utils/media-auth";
// import { StrictMode } from "react";

import "./styles/fonts.css";
import "./styles/globals.css";
import "swiper/css";
import "swiper/css/pagination";

// In autoUpdate mode the new worker activates immediately. Reload the current
// tab as soon as it takes control so the document and its lazy chunks always
// come from the same build.
registerSW({
  immediate: true,
  onNeedReload: () => window.location.reload(),
  onRegisterError: (error) => {
    console.error("[PWA] Service worker registration failed", error);
  },
});

initMediaAuth();

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  // </StrictMode>,
);
